export default "__VITE_ASSET__CgVs8gWa__"